import {Component, Input, OnInit} from '@angular/core';
import {IUser} from '../../models/auth';
import {IAppointment} from '../../models/appointment';

@Component({
  selector: 'app-consultations-details',
  templateUrl: './consultations-details.component.html',
  styleUrls: ['./consultations-details.component.scss']
})
export class ConsultationsDetailsComponent implements OnInit {
  @Input() users: IUser[] = [];
  @Input() appointmentData: IAppointment;
  @Input() totalAppointments: number;
  @Input() cardStyles;
  constructor() { }

  ngOnInit(): void {
  }

}
